import { render } from "./ModalStacking.vue?vue&type=template&id=4a2d0870"
import script from "./ModalStacking.vue?vue&type=script&lang=js"
export * from "./ModalStacking.vue?vue&type=script&lang=js"

import "./ModalStacking.vue?vue&type=style&index=0&id=4a2d0870&lang=css"
script.render = render

export default script